export interface RemoveReferralFormDto {
  removalReason: string;
}

export const createRemoveReferralFormDto = (): RemoveReferralFormDto => ({
  removalReason: "",
});
